import { ModelSagres } from "../../model-sagres";

export class CancelamentoLicitacaoDto extends ModelSagres {
  IdLicitacao: number;
  Tipo: string; //A, R, D ou F
  Justificativa: string;
  Data: Date;
  ArquivoParecer?: any;
}
